import { Box, Button, Heading, type HeadingProps, type MainVariant, Text } from '@doist/marketist';
import cn from 'clsx';
import css from './SectionHeader.module.css';
import type { CSSProperties } from 'react';
type CommonProps = {
  size?: 'base' | 'lg';
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  className?: string;
  level?: HeadingProps['level'];
  buttonVariant?: MainVariant;
  button?: React.ReactNode;
  textAlignment?: {
    wide: NonNullable<CSSProperties['textAlign']>;
    narrow: NonNullable<CSSProperties['textAlign']>;
  } | NonNullable<CSSProperties['textAlign']>;
  tag?: React.ElementType;
  style?: CSSProperties;
};
type ButtonLabel = {
  buttonLabel: string;
  onClickHandler: () => void;
};
type NoButtonLabel = {
  buttonLabel?: never;
  onClickHandler?: never;
};
type SectionHeaderProps = CommonProps & (ButtonLabel | NoButtonLabel);
export function SectionHeader({
  size = 'base',
  title,
  subtitle,
  buttonLabel,
  className,
  level = '3',
  buttonVariant = 'secondary',
  button,
  textAlignment,
  tag,
  style,
  onClickHandler
}: SectionHeaderProps) {
  let textAlignWide: CSSProperties['textAlign'] = 'center';
  let textAlignNarrow: CSSProperties['textAlign'] = 'center';
  if (textAlignment) {
    if (typeof textAlignment === 'string') {
      textAlignWide = textAlignment;
      textAlignNarrow = textAlignment;
    } else {
      textAlignWide = textAlignment.wide;
      textAlignNarrow = textAlignment.narrow;
    }
  }
  return <Box tag={tag} className={cn(css.sectionHeader, className, css[size])} style={{
    '--text-align': textAlignWide,
    '--text-align-narrow': textAlignNarrow,
    ...style
  }} data-sentry-element="Box" data-sentry-component="SectionHeader" data-sentry-source-file="SectionHeader.tsx">
            {title ? <Heading level={level} className={css.title} size={size === 'lg' ? 'major-lg' : 'major-base'}>
                    {title}
                </Heading> : null}
            {subtitle ? <Text className={css.subtitle} weight="medium" size={size === 'lg' ? 'body-lg' : 'body-base'}>
                    {subtitle}
                </Text> : null}
            {button ? <Box className={css.cta}>{button}</Box> : null}
            {buttonLabel ? <Button variant={buttonVariant} size={size === 'lg' ? 'large' : 'base'} onClick={onClickHandler} className={css.cta}>
                    {buttonLabel}
                </Button> : null}
        </Box>;
}